import { TokenType } from '../../types';
export default {
    'INJ-MASTER': {
        name: 'INJ Master',
        logo: 'mito-inj-master-lp.svg',
        symbol: 'INJ-MASTER-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
    'INJ-BOOST': {
        name: 'INJ Boost',
        logo: 'mito-inj-boost-lp.svg',
        symbol: 'INJ-BOOST-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
    'XAU-BOOST': {
        name: 'XAU Boost',
        logo: 'mito-xau-boost-lp.svg',
        symbol: 'XAU-BOOST-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
    'WETH-MASTER': {
        name: 'WETH Master',
        logo: 'mito-weth-master-lp.svg',
        symbol: 'WETH-MASTER-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
    'ETH-BOOST': {
        name: 'ETH Boost',
        logo: 'mito-eth-boost-lp.svg',
        symbol: 'ETH-boost-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
    'ATOM-MASTER': {
        name: 'ATOM Master',
        logo: 'mito-atom-master-lp.svg',
        symbol: 'ATOM-MASTER-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
    'ATOM-BOOST': {
        name: 'ATOM Boost',
        logo: 'mito-atom-boost-lp.svg',
        symbol: 'ATOM-BOOST-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
    'USDC-MASTER': {
        name: 'USDC Master',
        logo: 'mito-usdc-master-lp.svg',
        symbol: 'USDC-MASTER-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
    'PROJ-MASTER': {
        name: 'PROJ Master',
        logo: 'mito-proj-master-lp.svg',
        symbol: 'PROJ-MASTER-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
    'GBP-MASTER': {
        name: 'GBP Master',
        logo: 'mito-gbp-master-lp.svg',
        symbol: 'GBP-MASTER-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
    'EUR-MASTER': {
        name: 'EUR Master',
        logo: 'mito-eur-master-lp.svg',
        symbol: 'EUR-MASTER-LP',
        decimals: 18,
        coinGeckoId: '',
        cw20: {
            decimals: 18,
            address: '',
            tokenType: TokenType.Cw20,
        },
    },
};
//# sourceMappingURL=cw20-tokens.js.map